import React, { Component } from 'react';
import '../global';
import { uploadUserImage } from '../actions';
import { connect } from 'react-redux';
class SideBarWelcome extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userImage: account_info.user_image
        };
        this.fileInputRef = React.createRef();
        this.handleImageUpload = this.handleImageUpload.bind(this);
        this.handleFileChange = this.handleFileChange.bind(this);
    }

    handleImageUpload(){
        this.fileInputRef.current.click();
    }

    handleFileChange(event) {
        const file = event.target.files[0];
        if (file) {
            if (!file.type.startsWith('image/')) {
                alert('Please select an image file.');
                return;
            }

            const reader = new FileReader();
            reader.onload = (e) => {
                this.props.uploadUserImage(file).then(response => {
                    if (this.props.userImageStatus) {
                        this.setState({ userImage: e.target.result });
                    } else{
                        alert('An error occurred while uploading the image.');
                    }
                });
            };
            reader.onerror = (error) => {
                console.error('Error reading file:', error);
                alert('An error occurred while processing the image.');
            };
            reader.readAsDataURL(file);
        }
    }

    render() {
        return (
            <div className="side-bar-welcome">
                <div className="image-container">
                    <img src={this.state.userImage} alt="User" className="user-image" />
                    <div onClick={this.handleImageUpload} className="upload-icon">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_4539_3857)">
                        <path d="M20 15.8333C20 16.2942 19.6267 16.6667 19.1667 16.6667H16.6667V19.1667C16.6667 19.6275 16.2933 20 15.8333 20C15.3733 20 15 19.6275 15 19.1667V16.6667H12.5C12.04 16.6667 11.6667 16.2942 11.6667 15.8333C11.6667 15.3725 12.04 15 12.5 15H15V12.5C15 12.0392 15.3733 11.6667 15.8333 11.6667C16.2933 11.6667 16.6667 12.0392 16.6667 12.5V15H19.1667C19.6267 15 20 15.3725 20 15.8333ZM13.3333 5.83333C13.7925 5.83333 14.1667 5.46 14.1667 5C14.1667 4.54 13.7925 4.16667 13.3333 4.16667C12.8742 4.16667 12.5 4.54 12.5 5C12.5 5.46 12.8742 5.83333 13.3333 5.83333ZM4.00667 7.62583L0 11.6325V4.16667C0 1.86917 1.86917 0 4.16667 0H14.1667C16.4642 0 18.3333 1.86917 18.3333 4.16667V10H15.8333C14.5125 10 13.4292 11.0292 13.34 12.3275L8.63833 7.62583C7.36083 6.34833 5.28333 6.34833 4.00667 7.62583ZM10.8333 5C10.8333 6.37833 11.955 7.5 13.3333 7.5C14.7117 7.5 15.8333 6.37833 15.8333 5C15.8333 3.62167 14.7117 2.5 13.3333 2.5C11.955 2.5 10.8333 3.62167 10.8333 5ZM10 15.8333C10 14.6142 10.8767 13.5967 12.0333 13.3775L7.46 8.80417C6.83333 8.17833 5.81333 8.1775 5.185 8.80417L0 13.9892V14.1667C0 16.4642 1.86917 18.3333 4.16667 18.3333H10V15.8333Z" fill="#C6A57D"/>
                        </g>
                        <defs>
                        <clipPath id="clip0_4539_3857">
                        <rect width="20" height="20" fill="white"/>
                        </clipPath>
                        </defs>
                        </svg>
                    </div>
                    <input 
                        type="file" 
                        ref={this.fileInputRef} 
                        onChange={this.handleFileChange} 
                        style={{ display: 'none' }}
                        accept="image/*"
                    />
                </div>
                <div className="welcome-name-container">
                    <h3 className="welcome-name">Hi, {account_info.first_name}</h3>
                    <div className="welcome-email">
                        <span>{account_info.email}</span>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state){
    return {
        account_info: state.account_info,
        userImageStatus: state.userImageStatus
    };
}

export default connect(mapStateToProps, { uploadUserImage })(SideBarWelcome);